import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Modal, notification } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import ViewEquipmentEqu from '../../../Web/Client Management/EquipDetails/View';
import { GetAccess } from '../../../../Components/Utils/roles';
import axiosInstance from '../../../../Services/axiosCommon';
import More from '../../../../Components/Icons/More';
import EditEquipmentEqu from '../../../Web/Client Management/EquipDetails/Edit';


const EquipViewMore = ({ data, getData, id }) => {
  const { officeId } = useParams();
  const emailDelete = GetAccess("equipment_details_delete");
  const { confirm } = Modal;
  const [api, contextHolder] = notification.useNotification();

  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const handleDelete = async (id, removevalue) => {
    confirm({
      title: `Do you Want to delete ${removevalue}?`,
      centered: true,
      icon: <ExclamationCircleFilled />,
      content: `The ${removevalue} will be removed from the List`,
      okText: "Yes",
      cancelText: "No",
      onOk() {
        axiosInstance
          .delete(`/equipment-details/delete/${id}`)
          .then((res) => {
            if (res.status === 200 || res.status === 201) {
              getData();
              api.success({
                message: `Deleted successfully`,
                description: res?.data?.msg || " ",
                placement: "bottomRight",
              });
            } else {
              api.error({
                message: `Delete failed`,
                description: res?.data?.msg || "Network error",
                placement: "bottomRight",
              });
            }
          })
          .catch((error) => {
            api.error({
              message: `Delete failed`,
              description: error?.response?.data?.msg || "Server error",
              placement: "bottomRight",
            });
          });
      },
    });
  };

  const showViewModal = () => {
    setIsViewModalOpen(true);
  };

  const handleCloseViewModal = () => {
    setIsViewModalOpen(false);
  };

  const showEditModal = () => {
    setIsEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
  };

  return (
    <>
      {contextHolder}
      <div className="text-[#344767] relative dropdown inline-block z-50">
        <div className="cursor-pointer text-xs mx-auto font-semibold flex items-center">
          <span
            className="w-7 h-7 bg-gray-50 flex flex-col items-center justify-center rounded-full"
            style={{ border: "1px solid #C0C0C0" }}
          >
            <More />
          </span>
        </div>

        <ul className="dropdown-menuOne text-[#344767] text-left rounded-lg absolute -left-[80px] -top-4 overflow-hidden hidden z-50 shadow-lg">
          <li className="w-[100px] bg-black block m-0">
            <span
              className="bg-white hover:bg-gray-100 py-2 px-2 block whitespace-no-wrap text-xs font-medium text-black cursor-pointer"
              onClick={showViewModal}
            >
              View
            </span>
          </li>

          <li className="w-[100px] bg-black block m-0">
            <span
              className="bg-white hover:bg-gray-100 py-2 px-2 block whitespace-no-wrap text-xs font-medium text-black cursor-pointer"
              onClick={showEditModal}
            >
              Edit
            </span>
          </li>

          {emailDelete && (
            <li className="">
              <a
                className="bg-white hover:bg-gray-100 text-black hover:text-black py-2 px-2 block whitespace-no-wrap text-xs font-medium"
                href="#"
                onClick={() => handleDelete(id, data?.client)}
              >
                Delete
              </a>
            </li>
          )}
        </ul>
      </div>

      {/* Popup Modal with styled content */}
      <Modal
        open={isViewModalOpen}
        onCancel={handleCloseViewModal}
        footer={null}
        centered
        width={700}
        bodyStyle={{ paddingTop: 0 }}
      >
        <ViewEquipmentEqu item={data} />
      </Modal>

      <Modal
        open={isEditModalOpen}
        onCancel={handleCloseEditModal}
        footer={null}
        centered
        width={700}
        bodyStyle={{ paddingTop: 0 }}
      >
        <EditEquipmentEqu item={data} />
      </Modal>
    </>
  );
};

export default EquipViewMore;
